'use client';

import { InlineLinkProps } from './types';
import { forwardRef } from 'react';
import styled from 'styled-components';

const UnderlinedLink = styled.a`
  text-decoration: underline;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  color: ${(p) => p.theme.midwestColors.componentLinkDefault};

  &:hover {
    color: ${(p) => p.theme.midwestColors.componentLinkHover};
  }

  &:focus-visible {
    outline: ${(p) => p.theme.border.widthEmphasised} solid
      ${(p) => p.theme.midwestColors.borderFocus};
    border-radius: 5px;
  }
  &:visited {
    color: ${(p) => p.theme.midwestColors.componentLinkVisited};
  }
`;
/**
 ```jsx
 import { MDSInlineLink } from '@midwest/web/inline-link';
 ```
 * Underlined link component to be wrapped with a text component.
 */
export const MDSInlineLink = forwardRef<HTMLAnchorElement, InlineLinkProps>(
  ({ children, href, target, onClick, ...rest }: InlineLinkProps, ref) => {
    return (
      <UnderlinedLink
        href={href}
        ref={ref}
        onClick={onClick}
        target={target}
        {...rest}
      >
        {children}
      </UnderlinedLink>
    );
  },
);

MDSInlineLink.displayName = 'MDSInlineLink';
